import React from "react";
import {ContentCopy} from "@mui/icons-material";
import CopyToClipboard from "./index";
import IconButton from "../button/icon_button";

/**
 * Compact copy-to-clipboard icon button for system-generated codes.
 * Renders nothing when `value` is falsy.
 *
 * @param {{
 *   value?: string | number | null,
 *   size?: import('@mui/material').IconButtonProps['size'],
 *   color?: string,
 *   className?: string,
 *   disabled?: boolean,
 *   ariaLabel?: string,
 * }} props
 */
const CopyIconButton = ({
                            value,
                            size = 'small',
                            color = 'secondary',
                            className = 'ml-1',
                            disabled = false,
                            ariaLabel,
                        }) => {
    if (!value && value !== 0) {
        return null;
    }

    const content = String(value);

    return (
        <CopyToClipboard>
            {({copy}) =>
                <IconButton
                    size={size}
                    color={color}
                    className={className}
                    disabled={disabled}
                    aria-label={ariaLabel}
                    onPressed={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        copy(content);
                    }}
                >
                    <ContentCopy className={'icon small'}/>
                </IconButton>
            }
        </CopyToClipboard>
    );
};

export default CopyIconButton;
